<template>
  <div class="noticeboard">
    <div class="columns is-multiline is-gapless is-mobile">
      <div class="column ">
        <div class="section-block no-border is-column">
          <span class="title is-paddingless is-marginless">NOTICEBOARD</span>
          <small v-if="latestNotice"
            >Last notice: {{ latestNotice.createdAtFromNow }}</small
          >
        </div>
      </div>
      <div class="column is-narrow cta-btn">
        <b-button @click="postNotice" type="is-primary">Post Notice</b-button>
      </div>
    </div>
    <div>
      <noticeboard-card
        class="has-background-white"
        :notice="notice"
        :key="notice.id"
        see-more
        v-for="notice in notices.data"
      />
      <div v-if="!notices.data.length" class="has-text-centered">
        <span class="has-text-grey is-family-secondary is-size-6">
          No notice yet
        </span>
      </div>
      <div v-if="!isLastPage" class="has-text-centered tw-mt-5">
        <router-link
          :to="{ name: 'groups.noticeboard' }"
          class="is-clickable has-text-primary is-family-secondary is-size-6"
        >
          View more Notices
        </router-link>
      </div>
    </div>

    <!-- post notice dialog -->
    <post-notice @posted="onNoticePosted" ref="notice" />
  </div>
</template>

<script>
import PostNotice from '@/components/modals/PostNotice'
import NoticeboardCard from '@/components/NoticeboardCard'
import Notice from '@/models/Notice'
import { mapState } from 'vuex'
import { first } from 'lodash'
export default {
  components: {
    PostNotice,
    NoticeboardCard
  },
  data() {
    return {
      notices: {
        data: [],
        meta: {}
      }
    }
  },
  created() {
    this.getGroupNotices()
  },
  computed: {
    ...mapState({
      group: state => state.group.currentGroup
    }),
    latestNotice() {
      const notice = first(this.notices.data)
      if (notice) {
        return new Notice(notice)
      }
      return null
    },
    isLastPage() {
      const { meta } = this.notices
      return meta.current_page === meta.last_page
    }
  },
  methods: {
    postNotice() {
      this.$refs.notice.open()
    },
    getGroupNotices() {
      if (this.group) {
        this.group
          .notices()
          .params({
            page: this.notices.meta.current_page,
            limit: 5
          })
          .include('user')
          .get()
          .then(response => {
            this.notices = response
          })
      }
    },
    onNoticePosted() {
      this.getGroupNotices()
    }
  },
  watch: {
    group() {
      this.getGroupNotices()
    }
  }
}
</script>
